<div class="wrapper">
  <div class="container-skipper">
    <h2 class="letra">Iniciar sesión</h2>
    <h5 class="mb-3">Skipper-PJM</h5>

    <div class="upload-container">
      <div class="border-container letra">
        <hr>
        <p class="login-subtitle">Seleccioná el tipo de acceso</p>

        <button
          type="button"
          class="btn btn-login btn-block"
          *ngFor="let r of realms; let first = first"
          [class.mt-3]="!first"
          [disabled]="iniciandoRealm"
          (click)="ingresar(r.id)">
          {{ iniciandoRealm === r.id ? 'Redirigiendo...' : r.name }}
        </button> 

        <p class="login-error" *ngIf="error">{{ error }}</p>
        <hr>
      </div>
    </div>
  </div>
</div>
